import { applyCspNonceForDynamicElements, getCspNonce } from 'common/util/csp'

applyCspNonceForDynamicElements(getCspNonce())
